import { lazy } from 'react';

import { RoutesConfigType } from '@src/lib/types';

const ComingSoon = lazy(() => import('@src/screens/ComingSoon'));

const walletRoutes: Array<RoutesConfigType> = [{ path: '/wallet', component: ComingSoon, layout: 'private' }];

export default walletRoutes;
